import React, { useRef } from 'react';
import { Formik, Form, Field, FieldArray, ErrorMessage, getIn } from 'formik';
import * as Yup from 'yup';
import { KeenIcon, LazyFormikSelect, DatePicker, CustomOption, CustomSingleValue } from '@/components';
import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import flatFeesService from '@/services/billing/flatFeesService';
import matterService from '@/services/matter/matterService';
import itemService from '@/services/billing/itemService';
import userService from '@/services/setting/userService';
import { toast } from 'sonner';
import { Container } from '@/components/container';
import { useContactOptions, useLazyOptions, useLazyOptionsPerIndex } from '@/hooks';
import { ItemsModal } from '@/pages/billing';
import { useAbility } from '@/providers/';
import { Can } from '@casl/react';
import { InputSanitizers } from '@/utils'
import { PriceInput } from '@/components/form';
import { calculateSubtotal } from '@/utils';
import invoiceService from '@/services/billing/invoice/invoiceService';
import { formatDateToYMD } from '@/utils';
import { useUserOptions } from '@/hooks'

const AddFlatFees = () => {
    const [dataLoading, setDataLoading] = useState(false)
    const [flatFeeData, setFlatFeeData] = useState([]);
    const [userData, setuserData] = useState([]);
    const [matterData, setMatterData] = useState([])
    const [itemData, setItemData] = useState([])
    const [createContactLoading, setCreateContactLoading] = useState(false)
    const [open, setOpen] = useState(false);
    const [mode, setMode] = useState('create');
    const { id } = useParams();
    const flatFeeId = id;
    const Navigate = useNavigate()
    const formikRef = useRef();
    const [itemId, setItemId] = useState(null)
    const [selectedData, setSelectedData] = useState(null);
    const [isLoading, setIsLoading] = useState(false)
    const [loading, setLoading] = useState(false)
    const [taxesData, setTaxesData] = useState([])
    const { ability } = useAbility();
    const loadUserOptions = useUserOptions({ defaultPageSize: 20 });


    const validationSchema = Yup.object().shape({
        flat_fees: Yup.array()
            .of(
                Yup.object().shape({
                    contact_id: Yup.string()
                        .required('Contact is required'),
                    matter_id: Yup.string()
                        .required('Matter is required'),
                    item_id: Yup.string()
                        .required('Item is required'),
                    date: Yup.date()
                        .required('Date is required')
                        .typeError('Invalid date format'),
                    date_to: Yup.date()
                        .transform((value, original) => (original === '' || original === null ? null : value))
                        .nullable()
                        .min(Yup.ref('date'), 'The end date must be on or after the start date')
                        .typeError('Invalid date format'),
                    quantity: Yup.number()
                        .required('Quantity is required')
                        .min(1, 'Quantity must be at least 1')
                        .typeError('Quantity must be a number'),
                    price: Yup.number()
                        .required('Price is required')
                        .min(0, 'Price cannot be negative')
                        .typeError('Price must be a number'),
                })
            )
            .max(10, 'Only up to 10 flat fees allowed'),
    });

    const initialValues = {
        flat_fees: [
            {
                contact_id: flatFeeData?.contact_id || '',
                contact: flatFeeData?.contact
                    ? {
                        label: `${flatFeeData.contact.first_name} ${flatFeeData.contact.last_name}`,
                        value: flatFeeData.contact.id,
                        id: flatFeeData.contact.id
                    }
                    : null,
                matter_id: flatFeeData?.matter_id || '',
                matter: flatFeeData?.matter
                    ? {
                        label: flatFeeData.matter.name,
                        value: flatFeeData.matter.id,
                        id: flatFeeData.matter.id
                    }
                    : null,
                item_id: flatFeeData?.item_id || '',
                item: flatFeeData?.item
                    ? {
                        label: flatFeeData.item.name,
                        value: flatFeeData.item.id,
                        id: flatFeeData.item.id
                    }
                    : null,
                date: formatDateToYMD(flatFeeData?.date || ''),
                date_to: formatDateToYMD(flatFeeData?.date_to || ''),
                quantity: flatFeeData?.quantity || 1,
                rate: flatFeeData?.rate || '',
                billed_by: flatFeeData?.billed_by?.id || '',
                billed_by_user: flatFeeData?.billed_by
                    ? {
                        label: `${flatFeeData.billed_by.first_name} ${flatFeeData.billed_by.last_name}`,
                        value: flatFeeData.billed_by.id,
                        id: flatFeeData.billed_by.id,
                        email: flatFeeData.billed_by.email
                    } : null,
                status: flatFeeData?.status || 'billable',
                description: flatFeeData?.description || '',
                note: flatFeeData?.note || '',
            }
        ]
    }
    console.log(initialValues,)

    const handleSubmit = async (formData, resetForm, setErrors) => {
        setCreateContactLoading(true);
        try {
            const { data, status } = await flatFeesService.createFlatFees(formData);
            if (status) {
                resetForm()
                toast.success('Flat Fees Created.', {
                    description: `Flat Fees Created Successfully.`,
                    action: {
                        label: 'Ok',
                    },
                });
                Navigate('/billing/flat-fees')
            }
        } catch (error) {
            console.error('Error', error)
            if (error.message == '422 Unprocessable Entity. Validation failed.') {
                // Validation for numbers
                const responseErrors = error.errors || {};
                const formattedErrors = {};

                Object.entries(responseErrors).forEach(([key, value]) => {
                    if (key.startsWith('phone_number')) {
                        // Extract index and nested field from e.g. "phone_number.0.number"
                        const match = key.match(/^phone_number\.(\d+)\.(\w+)$/);
                        if (match) {
                            const [, index, field] = match;

                            if (!formattedErrors.phone_number) {
                                formattedErrors.phone_number = [];
                            }

                            formattedErrors.phone_number[Number(index)] = {
                                ...(formattedErrors.phone_number[Number(index)] || {}),
                                [field]: value[0], // or join with \n if multiple messages
                            };
                        }
                    } else {
                        formattedErrors[key] = value[0]; // single error message
                    }
                });
                // console.log(formattedErrors)
                setErrors(formattedErrors)
                if (responseErrors["phone_number.0.number"] || responseErrors["phone_number.1.number"] || responseErrors["phone_number.2.number"]) {
                    toast.warning('Mobile Number Already Taken.', {
                        description: 'Please check you Mobile Numbers. it has has already been taken.',
                        action: {
                            label: 'Ok',
                        },
                    });
                    return
                }
                toast.warning('Validation Error.', {
                    description: 'Please check your input. Some fields may be invalid.',
                    action: {
                        label: 'Ok',
                    },
                });
                return
            }
            toast.error('Oops! Something went wrong.', {
                description: 'An error occurred while creating Flat Fees. Please try again in a moment.',
                action: {
                    label: 'Ok',
                },
            });
        } finally {
            setCreateContactLoading(false);
        }
    };

    const handleSubmitItem = async (formData) => {
        setIsLoading(true)
        try {
            const { data, status } = await itemService.createItem(formData);
            if (status) {
                resetItems()
                setOpen(false)
                getAllItems()
                toast.success('Item Created Successfully.', {
                    description: `${data.name} item Created Successfully.`,
                    action: {
                        label: 'Ok',
                    },
                });
            }
        } catch (error) {
            console.error('Error', error)
            if (error.message == '422 Unprocessable Entity. Validation failed.') {
                const validationErrors = error.errors
                const formattedErrors = Object.fromEntries(
                    Object.entries(validationErrors).map(([key, value]) => [key, value[0]])
                );

                formikRef.current?.setErrors(formattedErrors);
                toast.error('Validation Error.', {
                    description: 'Please check your input. Some fields may be invalid.',
                    action: {
                        label: 'Ok',
                    },
                });
            }
        } finally {
            setIsLoading(false)
        }
    };

    const getSingleFlatFee = async (flatFeeId) => {
        setDataLoading(true)
        try {
            const { data, status } = await flatFeesService.getSingleFlatFees(flatFeeId);
            if (status) {
                setFlatFeeData(data)
            }
        } catch (error) {
            console.error('Error', error)
            toast.error('Failed to fetch Contact.', {
                description: 'An error occurred while fetching contact. Please try again later.',
            });
        } finally {
            setDataLoading(false)
        }
    }

    const loadContactOptions = useContactOptions({ defaultPageSize: 20 });


    const getAllMatters = async () => {
        setDataLoading(true)
        try {
            const { data, status } = await matterService.getAllMatters();
            if (status) {
                const Data = data.map(matter => ({
                    label: matter.name,
                    value: matter.id.toString(),
                    id: matter.id.toString(),
                }));
                setMatterData(Data)
                return Data
            }
        } catch (error) {
            console.error('Error', error)
            toast.error('Failed to fetch Matters.', {
                description: 'An error occurred while fetching matters. Please try again later.',
            });
        } finally {
            setDataLoading(false)
        }
    }

    const getAllMattersRelatedToContact = async (contactId, index) => {
        console.log('id', contactId)
        setDataLoading(true)
        try {
            const { data, status } = await invoiceService.getContactMatterRelatedData('contact', contactId);
            if (status) {
                return data.matters.map(m => ({
                    label: m.name,
                    value: m.id.toString(),
                    id: m.id.toString(),
                }));
            }
            return [];
        } catch (error) {
            console.error('Error', error)
            toast.error('Failed to fetch Matters.', {
                description: 'An error occurred while fetching matters. Please try again later.',
            });
        } finally {
            setDataLoading(false)
        }
    }

    const {
        dataMap: matterOptionsByIndex,
        loadingMap: matterLoadingByIndex,
        load: loadMattersByIndex,
    } = useLazyOptionsPerIndex(async (contactId) => {
        if (!contactId) {
            return
            // await getAllMatters(); // fallback
        }
        return await getAllMattersRelatedToContact(contactId);
    });

    const getAllItems = async () => {
        setDataLoading(true)
        try {
            const { data, status } = await itemService.getAllItem();
            if (status) {
                const Data = data.map(item => ({
                    label: item.name,
                    value: item.id.toString(),
                    id: item.id.toString(),
                    rate: item.rate
                }));
                setItemData(Data)
                return Data
            }
        } catch (error) {
            console.error('Error', error)
            toast.error('Failed to fetch Items.', {
                description: 'An error occurred while fetching items. Please try again later.',
            });
        } finally {
            setDataLoading(false)
        }
    }
    const {
        data: itemOptions,
        loading: itemLoading,
        load: loadItems,
        reset: resetItems
    } = useLazyOptions(getAllItems);


    useEffect(() => {
        if (flatFeeId) {
            getSingleFlatFee(flatFeeId)
        } else {
            setFlatFeeData({})
        }
    }, [])

    const handleModalClose = () => {
        setItemId(null)
        setSelectedData(null)
        setMode('create')
        setOpen(false)
    }

    return (
        <>
            <Formik
                enableReinitialize
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={(values, { resetForm, setErrors }) => {
                    handleSubmit(values, resetForm, setErrors);
                    console.log('Submitted:', values);
                }}
            >
                {({ values, errors, setFieldValue }) => (
                    <Container>
                        <Form className='card'>
                            <div className="card-header">
                                <h3 className="card-title">Create Flat Fees</h3>
                            </div>
                            <FieldArray name="flat_fees" className="card">
                                {({ push, remove }) => (
                                    <>
                                        {values.flat_fees.map((_, index) => (
                                            <div key={index} className='card-body'>
                                                <h4 className='mb-3 text-sm'>Flat Fee #{index + 1}</h4>

                                                <div className="grid gap-5 xs:grid-cols-3">
                                                    <div>
                                                        <label className="mb-1 form-label">Contact <span className='pl-px text-red-600'>*</span></label>
                                                        <LazyFormikSelect
                                                            name={`flat_fees[${index}].contact_id`}
                                                            placeholder="Select Contact"
                                                            loadOptions={loadContactOptions}
                                                            pageSize={20}
                                                            preloadedOption={initialValues?.flat_fees[0].contact}
                                                            onOptionSelect={(selected) => {
                                                                if (selected?.id) {
                                                                    // loadMatters(selected.id, true);
                                                                    loadMattersByIndex(selected?.id || null, index)
                                                                    setFieldValue(`flat_fees[${index}].matter_id`, '')
                                                                }
                                                            }}
                                                        />
                                                        <ErrorMessage
                                                            name={`flat_fees[${index}].contact_id`}
                                                            component="div"
                                                            className="mt-1 text-xs text-red-500"
                                                        />
                                                    </div>
                                                    <div>
                                                        <label className="mb-1 form-label">Matter <span className='pl-px text-red-600'>*</span></label>
                                                        <LazyFormikSelect
                                                            name={`flat_fees[${index}].matter_id`}
                                                            options={matterOptionsByIndex[index] || []}
                                                            placeholder="Select Matter"
                                                            onFocus={() => {
                                                                const contactId = getIn(values, `flat_fees[${index}].contact_id`);
                                                                // loadMatters(contactId || null);
                                                                loadMattersByIndex(contactId || null, index);
                                                            }}
                                                            isLoading={matterLoadingByIndex[index] === true}
                                                            preloadedOption={initialValues.flat_fees[0].matter}

                                                        />
                                                        <ErrorMessage name={`flat_fees[${index}].matter_id`} component="div" className="mt-1 text-xs text-red-500" />
                                                    </div>
                                                    <div>
                                                        <label className="mb-1 form-label">Item <span className='pl-px text-red-600'>*</span></label>
                                                        {/* <FormikSelect
                                                    name={`flat_fees[${index}].item_id`}
                                                    options={itemData}
                                                    placeholder="Select an item"
                                                /> */}
                                                        <LazyFormikSelect
                                                            name={`flat_fees[${index}].item_id`}
                                                            options={itemOptions}
                                                            placeholder="Select an Item"
                                                            onFocus={() => loadItems(null)}
                                                            isLoading={itemLoading}
                                                            preloadedOption={initialValues.flat_fees[0].item}
                                                            noOptionsMessage={() => (
                                                                isLoading ? (
                                                                    <span className="text-sm">Loading...</span>
                                                                ) : (
                                                                    <div>
                                                                        <span className="mr-1 text-sm">No options available</span>
                                                                        <Can I='handle' a='items' ability={ability}>
                                                                            <button type="button"
                                                                                onClick={() => setOpen(true)}
                                                                                className="text-sm text-blue-500 underline"
                                                                            >
                                                                                Add new
                                                                            </button>
                                                                        </Can>
                                                                    </div>
                                                                )
                                                            )}
                                                            onOptionSelect={(selected) => {
                                                                if (selected?.id) {
                                                                    setFieldValue(`flat_fees[${index}].rate`, selected.rate);
                                                                }
                                                            }}
                                                        />
                                                        <ErrorMessage name={`flat_fees[${index}].item_id`} component="div" className="mt-1 text-xs text-red-500" />
                                                    </div>
                                                    <div className='w-full'>
                                                        <label className="mb-1 form-label">Billed By</label>
                                                        <LazyFormikSelect
                                                            name={`flat_fees[${index}].billed_by`}
                                                            placeholder="Select Assignee"
                                                            loadOptions={loadUserOptions}
                                                            pageSize={20}
                                                            preloadedOption={initialValues.flat_fees[0].billed_by_user}
                                                            components={{
                                                                Option: CustomOption,
                                                                SingleValue: CustomSingleValue,
                                                            }}
                                                        />
                                                        <ErrorMessage name={`flat_fees[${index}].billed_by`} component="div" className="mt-1 text-xs text-red-500" />
                                                    </div>
                                                    <div>
                                                        <label className="mb-1 form-label">Quantity <span className='pl-px text-red-600'>*</span></label>
                                                        <Field className="input" type="text" name={`flat_fees[${index}].quantity`} onInput={InputSanitizers} />
                                                        <ErrorMessage name={`flat_fees[${index}].quantity`} component="div" className="mt-1 text-xs text-red-500" />
                                                    </div>
                                                    <div>
                                                        <label className="mb-1 form-label">Rate <span className='pl-px text-red-600'>*</span></label>
                                                        <PriceInput name={`flat_fees[${index}].rate`} prefix="$" />
                                                        {/* <Field className="input" type="text" name={`flat_fees[${index}].price`} onInput={InputSanitizers} /> */}
                                                        {/* <ErrorMessage name={`flat_fees[${index}].price`} component="div" className="mt-1 text-xs text-red-500" /> */}
                                                    </div>
                                                </div>

                                                <div className="grid grid-cols-3 gap-5 mt-5">
                                                    <div className=''>
                                                        <label className="mb-1 form-label">Total</label>
                                                        <div className='input'>
                                                            {calculateSubtotal(values.flat_fees[index].rate, values.flat_fees[index].quantity)}
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <label className="mb-1 form-label">Date <span className='pl-px text-red-600'>*</span></label>
                                                        <Field name={`flat_fees[${index}].date`}>
                                                            {({ field, form, meta }) => (
                                                                <div>
                                                                    <DatePicker field={field} form={form} isRange={false} />
                                                                    {meta.touched && meta.error && (
                                                                        <div className="mt-1 text-xs text-red-500">{meta.error}</div>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </Field>
                                                    </div>
                                                    <div>
                                                        <label className="mb-1 form-label">To <span className='text-[11px]'>(optional)</span></label>
                                                        <Field name={`flat_fees[${index}].date_to`}>
                                                            {({ field, form, meta }) => (
                                                                <div>
                                                                    <DatePicker field={field} form={form} isRange={false} />
                                                                    {meta.touched && meta.error && (
                                                                        <div className="mt-1 text-xs text-red-500">{meta.error}</div>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </Field>
                                                    </div>
                                                    <div>
                                                        <label className="mb-1 form-label">Status</label>
                                                        <Field as="select" className="input" name={`flat_fees[${index}].status`}>
                                                            <option value="billable">Billable</option>
                                                            <option value="billed">Billed</option>
                                                            <option value="paid">Paid</option>
                                                            <option value="not billable">Not Billable</option>

                                                        </Field>
                                                    </div>
                                                </div>

                                                <div className='grid grid-cols-2 gap-5 mt-5'>
                                                    <div>
                                                        <label className="mb-1 form-label">Description</label>
                                                        <Field as="textarea" className="input pt-2 h-[120px]" name={`flat_fees[${index}].description`} />
                                                    </div>
                                                    <div>
                                                        <label className="mb-1 form-label">Note</label>
                                                        <Field as="textarea" className="input pt-2 h-[120px]" name={`flat_fees[${index}].note`} />
                                                    </div>
                                                </div>


                                                {/* Remove Button */}
                                                {values.flat_fees.length > 1 && (
                                                    <button type="button" className='my-2 btn btn-sm btn-danger btn-outline' onClick={() => remove(index)}>
                                                        <KeenIcon icon="trash" />
                                                        Remove
                                                    </button>
                                                )}
                                            </div>
                                        ))}

                                        {/* Add Button */}
                                        <div className='flex items-center justify-end gap-1 card-body'>
                                            {!flatFeeId && values.flat_fees.length < 10 && (
                                                <button type="button" className='btn btn-sm' onClick={() => push({
                                                    contact_id: '',
                                                    matter_id: '',
                                                    item_id: '',
                                                    date: '',
                                                    date_to: '',
                                                    quantity: 1,
                                                    price: '',
                                                    billed_by: "",
                                                    billed_by_user: null,
                                                    status: 'billable',
                                                    description: '',
                                                    note: '',
                                                })}>
                                                    Add Form
                                                </button>
                                            )}
                                            <button type="submit" disabled={createContactLoading} className="btn btn-primary">
                                                {createContactLoading ? 'Please Wait...' : 'Create Flat Fee'}
                                            </button>
                                        </div>
                                    </>
                                )}
                            </FieldArray>
                        </Form>
                    </Container>
                )}
            </Formik>
            <ItemsModal
                open={open}
                onCloseModal={handleModalClose}
                handleMode={mode}
                data={selectedData}
                onSubmit={handleSubmitItem}
                createFieldLoading={isLoading}
                updateFieldLoading={loading}
                taxesData={taxesData}
                ref={formikRef}
            />
        </>
    );
};

export { AddFlatFees };
